import { render, staticRenderFns } from "./FounderSection.vue?vue&type=template&id=6d86ca8e&scoped=true"
import script from "./FounderSection.vue?vue&type=script&lang=js"
export * from "./FounderSection.vue?vue&type=script&lang=js"
import style0 from "./FounderSection.vue?vue&type=style&index=0&id=6d86ca8e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d86ca8e",
  null
  
)

export default component.exports